import { type PaymentTermConstructor } from '../../entities/PaymentTerm'
import { type PaymentTermApiModel } from '../api-models/PaymentTermApiModel'

export const mapPaymentTermApiModel = (
  data: PaymentTermApiModel
): PaymentTermConstructor => ({
  id: data.id,
  name: data.name,
  description: data.description,
  active: data.active,
})
